import { Injectable } from '@angular/core'
import { AuthService } from '@spartacus/core'
import { QuoteCartService } from '../../quote/quote-services/quote-cart.service'
import { Observable } from 'rxjs'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { CommonService } from '../../../shared/services/common.service'
export const headerOptions = { responseType: 'text' as 'json' }

let productId: any
@Injectable({
  providedIn: 'root',
})
export class PDPService {
  userType: string
  cartId: string
  cartId$: Observable<string> = this.activeCartService.getActiveCartId()
  activeCart: any
  rfqCartId: any
  currentProduct: any
  constructor(
    public commonService: CommonService,
    private auth: AuthService,
    public quoteCartServce: QuoteCartService,
    public activeCartService: ActiveCartFacade
  ) {
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.userType = 'current'
          this.cartId$.subscribe((data) => {
              this.cartId = data
          })
      } else {
        this.userType = 'anonymous'
      }
      this.rfqCartId = sessionStorage.getItem('cartId-' + this.userType)
    })
  }

  addBOMProductstoCart(bomProducts, cartId) {
    this.cartId = cartId
    let orderEntries = bomProducts
    const urlParam = ['users', 'current', 'carts', this.cartId, 'bomEntries']
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.postData(apiUrl, { orderEntries })
  }

  getProduct(id) {
    const urlParam = ['products']
    let lastPart = `productCode?`
    lastPart += `productCode=${id}`
    urlParam.push(lastPart)
    const apiUrl = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(apiUrl)
  }

  setProductId(id) {
    productId = id
  }

  // public priceandAvailabilitySource = new BehaviorSubject(this.getProduct(productId));
  // passPriceAndAvailablityProductCount = this.priceandAvailabilitySource.asObservable();
  addBOMProductstoQuoteCart(bomProducts) {
    if (!this.rfqCartId) {
      this.getRFQCartId().subscribe((success) => {
        if (this.userType === 'current') {
          this.rfqCartId = success['code']
        } else {
          this.rfqCartId = success['guid']
        }
        sessionStorage.setItem('cartId-' + this.userType, this.rfqCartId)
        sessionStorage.setItem('cartStatus-' + this.userType, 'added')
      })
    }
    let i = 0
    for (i = 0; i < bomProducts.length; i++) {
      this.quoteCartServce
        .addProduct(this.userType, this.rfqCartId, bomProducts[i])
        .subscribe(
          (success) => {},
          (error) => {
            return false
          }
        )
    }
    return true
  }
  getCart() {}

  getRFQCartId() {
    var a
    return this.quoteCartServce.getCart(a, this.userType)
  }
  updateProductFavouriteStatus(product, value?) {
    const urlparams = ['users', 'current', 'saveProductsToFavourites']
    const apiUrl = this.commonService.constructUrl(urlparams)
    const formData = new FormData()
    formData.append('code', product.code)
    formData.append('comment', value)
    return this.commonService.postData(apiUrl, formData, headerOptions)
  }
}
